import CommonHeader from "../../../components/ui/CommonHeader";
import ContentText from "../../../components/ui/ContentText";
import WebLayout from "../../../layouts/web";
import Footer from "../../../layouts/web/_components/footer";
import Platform from "../../../layouts/web/_components/platform";

export default function PrivacyPolicy() {
  return (
    <WebLayout>
      <CommonHeader
        title="COMPREHENSIVE PRIVACY POLICY"
        description="Last Updated: January 8, 2026"
      />

      <div className="mini-container md:!max-w-[800px] pt-28">
        <ContentText title="1. MISSION AND SCOPE" classNames={{ root: "mb-8" }}>
          ManPowerX ("the Platform," "we," "us," or "our") provides a
          specialized Learning Management System (LMS) tailored for the
          blue-collar workforce, including construction, manufacturing,
          logistics, and energy sectors. We recognize that the data we handle
          ranging from basic identity to high-stakes safety certifications is
          vital to the livelihoods of our users and the operational safety of
          their employers.
          <br />
          <br />
          ManPowerX ("the Platform," "we," "us," or "our") provides a
          specialized Learning Management System (LMS) tailored for the
          blue-collar workforce, including construction, manufacturing,
          logistics, and energy sectors. We recognize that the data we handle
          ranging from basic identity to high-stakes safety certifications is
          vital to the livelihoods of our users and the operational safety of
          their employers. This Privacy Policy is a legally binding document
          that outlines our rigorous standards for data collection, processing,
          storage, and protection. It applies to all users of the ManPowerX
          website, mobile application, and integrated offline learning modules.
        </ContentText>

        <ContentText title="2. DEFINITIONS" classNames={{ root: "mb-8" }}>
          To ensure absolute clarity, the following terms are defined for the
          purposes of this policy:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>
              <span className="text-theme-zinc-700 font-medium">
                "Learner":
              </span>{" "}
              Any individual employee, contractor, or apprentice using the
              Platform to consume educational content.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                "Employer":
              </span>{" "}
              The corporate entity or organization that has licensed ManPowerX
              to provide training to its workforce.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                "Personal Data":
              </span>{" "}
              Any information relating to an identified or identifiable natural
              person.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                "Processing":
              </span>{" "}
              Any operation performed on personal data, such as collection,
              recording, organization, structuring, or storage.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                "Data Controller":
              </span>{" "}
              In most instances, your Employer is the Controller of your data,
              and ManPowerX acts as the Data Processor.
            </li>
          </ul>
        </ContentText>

        <ContentText
          title="3. CATEGORIES OF DATA COLLECTED"
          subTitle="3.1 Personal Identification and Contact Information"
        >
          Upon account creation whether initiated by the Learner or
          pre-provisioned by the Employer we collect:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Full Legal Name:
              </span>{" "}
              Required for official certification validity.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Government-Issued Identifiers:
              </span>{" "}
              In specific jurisdictions, social security numbers or national ID
              numbers may be collected if required for mandatory government
              safety filings (e.g., OSHA reporting).
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Digital Contact Data:
              </span>{" "}
              Professional email addresses, personal email addresses (if used
              for recovery), and mobile phone numbers (used for SMS-based
              Multi-Factor Authentication).
            </li>
          </ul>
        </ContentText>

        <ContentText subTitle="3.2 Professional and Employment Context">
          To categorize training requirements, we collect:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Job Metrics:
              </span>{" "}
              Title, department, union affiliation, employee ID, and site
              location.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Supervisory Data:
              </span>{" "}
              The name and ID of the direct manager or foreman responsible for
              the Learner’s safety compliance.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Skill Profiles:
              </span>{" "}
              Current licenses held, years of experience in a specific trade,
              and machinery operation history.
            </li>
          </ul>
        </ContentText>

        <ContentText subTitle="3.4 Technical and Telemetric Data">
          To ensure the Platform functions on ruggedized devices and in remote
          areas:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Device Metadata:
              </span>{" "}
              Operating system version, browser type (e.g., Chrome, Safari), and
              hardware identifiers.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Network Data:
              </span>{" "}
              IP addresses, ISP information, and connection speed (to optimize
              video delivery).
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Cookie Data:
              </span>{" "}
              We use session cookies and persistent cookies to maintain login
              states and user preferences (e.g., language settings for
              multi-lingual workforces).
            </li>
          </ul>
        </ContentText>

        <ContentText subTitle="3.5 Sensitive Personal Information (SPI)">
          Under certain circumstances, we may process SPI:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Biometric Data:
              </span>{" "}
              If an Employer requires facial recognition or fingerprint scanning
              to prevent "proxy testing" (someone else taking a test for the
              Learner).
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Health Data:
              </span>{" "}
              Limited to "fitness for duty" certifications or records of
              physical accommodations required for practical training.
            </li>
          </ul>
        </ContentText>

        <ContentText title="4. SOURCES OF INFORMATION">
          We collect data through three primary channels:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Directly from the Learner:
              </span>{" "}
              Information entered during profile setup, assessments, or feedback
              surveys.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                From the Employer:
              </span>{" "}
              Bulk uploads of employee rosters via CSV or API integrations with
              HR Information Systems (HRIS) like Workday, SAP SuccessFactors, or
              ADP.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Automated Tracking:
              </span>{" "}
              Telemetry gathered as the user interacts with the web or mobile
              interface.
            </li>
          </ul>
        </ContentText>

        <ContentText
          title="5. PURPOSES OF DATA PROCESSING"
          subTitle="5.1 Service Delivery and Functional Necessity"
        >
          The primary reason we process data is to fulfill our contractual
          obligation to provide the LMS. This includes:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>Authenticating users.</li>
            <li>Delivering video-based safety modules.</li>
            <li>
              Synchronizing progress between the mobile app and the desktop
              portal.
            </li>
          </ul>
        </ContentText>
        <ContentText subTitle="5.2 Regulatory and Legal Compliance">
          For blue-collar industries, training is often a legal mandate. We
          process data to:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>Generate "Proof of Training" for government audits.</li>
            <li>Maintain "Chain of Custody" for safety certifications.</li>
            <li>Comply with industrial accident investigation requests.</li>
          </ul>
        </ContentText>
        <ContentText subTitle="5.3 Platform Optimization and AI Development">
          We use de-identified, aggregated data to:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>
              Train machine learning models that predict which employees are at
              the highest risk of safety incidents based on training gaps.
            </li>
            <li>
              Improve the user interface for workers with lower digital
              literacy.
            </li>
            <li>
              Monitor system performance to prevent downtime during peak
              shift-change hours.
            </li>
          </ul>
        </ContentText>

        <ContentText
          title="6. DATA SHARING AND THIRD-PARTY DISCLOSURES"
          subTitle="6.1 Disclosures to the Employer"
        >
          The Employer, as the licensee of ManPowerX, has full visibility into:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>Which employees have completed mandatory safety training.</li>
            <li>Aggregate performance of specific crews or sites.</li>
            <li>Individual scores on competence exams.</li>
          </ul>
        </ContentText>
        <ContentText subTitle="6.2 Disclosures to Third-Party Sub-Processors">
          We engage specialized partners to enhance our service. These partners
          are bound by strict Data Processing Agreements (DPAs):
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>
              <span className="text-theme-zinc-700 font-medium">Hosting:</span>{" "}
              Amazon Web Services (AWS) or Microsoft Azure (Encrypted storage).
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Video Delivery:
              </span>{" "}
              Content Delivery Networks (CDNs) like Cloudflare
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Communication:
              </span>{" "}
              Twilio or SendGrid for SMS and email alerts.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Analytics:
              </span>{" "}
              Google Analytics (anonymized) for site performance tracking.
            </li>
          </ul>
        </ContentText>
        <ContentText subTitle="6.3 Disclosures for Legal Reasons">
          We may disclose Personal Data if required to do so by law or in the
          good faith belief that such action is necessary to:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>Respond to a court order or subpoena.</li>
            <li>Protect the personal safety of users on a job site.</li>
            <li>
              Investigate fraud or platform abuse (e.g., automated scripts
              taking exams).
            </li>
          </ul>
        </ContentText>
        <ContentText title="7. INTERNATIONAL DATA TRANSFERS">
          ManPowerX is a global platform. Data collected in the European
          Economic Area (EEA), United Kingdom, or Canada may be transferred to
          servers located in the United States.
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Standard Contractual Clauses (SCCs):
              </span>{" "}
              We utilize SCCs to ensure that data transferred outside the EEA is
              protected to an equivalent standard.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Data Residency:
              </span>{" "}
              For premium enterprise clients, we offer localized data residency
              options where data remains within the jurisdiction of origin.
            </li>
          </ul>
        </ContentText>
        <ContentText title="8. DATA SECURITY ARCHITECTURE">
          We employ a "Defense in Depth" strategy to protect blue-collar
          workforce data:
        </ContentText>
        <ContentText subTitle="8.1 Encryption">
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>
              <span className="text-theme-zinc-700 font-medium">
                In Transit:
              </span>{" "}
              All data is protected via Transport Layer Security (TLS) 1.2 or
              1.3.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">At Rest:</span>{" "}
              Databases are encrypted using AES-256.
            </li>
          </ul>
        </ContentText>
        <ContentText subTitle="8.2 Access Control">
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Least Privilege:
              </span>{" "}
              ManPowerX employees only access user data if necessary for
              technical support.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">At MFA:</span>{" "}
              Multi-Factor Authentication is mandatory for all administrative
              accounts.
            </li>
          </ul>
        </ContentText>

        <ContentText title="9. DATA RETENTION AND DELETION">
          How long we keep data depends on the nature of the information:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Active Accounts:
              </span>{" "}
              Data is kept for the duration of the contract with the Employer.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Terminated Employees:
              </span>{" "}
              If a Learner leaves their company, ManPowerX typically retains
              their training records for seven (7) years to satisfy statute of
              limitations for industrial liability claims, unless otherwise
              instructed by the Employer or local law.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Anonymized Data:
              </span>{" "}
              We may retain de-identified data indefinitely for statistical and
              research purposes.
            </li>
          </ul>
        </ContentText>

        <ContentText
          title="10. USER RIGHTS (GLOBAL STANDARDS)"
          subTitle="10.1 Rights under GDPR (Europe)"
        >
          Users in the EEA have the right to:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>
              <span className="text-theme-zinc-700 font-medium">Access:</span>{" "}
              Request a digital copy of all personal data.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Rectification:
              </span>{" "}
              Correct inaccurate certifications.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Erasure ("Right to be Forgotten"):
              </span>{" "}
              Request deletion, provided it doesn't conflict with legal safety
              record requirements.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Data Portability:
              </span>{" "}
              Move training records to a different LMS.
            </li>
          </ul>
        </ContentText>
        <ContentText subTitle="10.2 Rights under CCPA/CPRA (California)">
          California residents have specific rights regarding the "sale" of
          data. ManPowerX does not sell personal data.
        </ContentText>
        <ContentText title="11. CHILDREN'S PRIVACY">
          The ManPowerX platform is strictly intended for adult workers (18+) or
          legally registered apprentices (16+ with parental/employer consent).
          We do not knowingly collect data from individuals under the age of 16.
          If we discover such data has been collected, it will be purged
          immediately.
        </ContentText>
        <ContentText title="12. COOKIES AND TRACKING TECHNOLOGIES">
          We use cookies to enhance the user experience:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Essential Cookies:
              </span>{" "}
              Necessary for login and security.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Preference Cookies:
              </span>{" "}
              Remember your language (e.g., Spanish vs. English).
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Performance Cookies:
              </span>{" "}
              Help us understand which course videos are loading slowly.
            </li>
          </ul>
        </ContentText>
        <ContentText title="13. AUTOMATED DECISION-MAKING">
          ManPowerX may use algorithms to:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>Recommend specific courses based on a user’s job title.</li>
            <li>
              Flag suspicious exam patterns for manual review by a foreman.
            </li>
            <li>
              Note: No automated decision that has a "legal or significantly
              similar effect" (like firing an employee) is made solely by the AI
              without human intervention by the Employer.
            </li>
          </ul>
        </ContentText>
        <ContentText title="14. MOBILE APP SPECIFICS">
          The ManPowerX Mobile App may request the following permissions:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>
              <span className="text-theme-zinc-700 font-medium">Camera:</span>{" "}
              For scanning QR codes on equipment or uploading profile photos.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">Storage:</span>{" "}
              To download course materials for offline use at remote job sites.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">Location:</span>{" "}
              To verify that "Site-Specific Safety Induction" is actually
              performed at the job site.
            </li>
          </ul>
        </ContentText>
        <ContentText
          title="15. CHANGES TO THIS PRIVACY POLICY"
          classNames={{ root: "mb-0" }}
        >
          The landscape of data privacy and industrial regulation is constantly
          evolving. When we update this policy, we will:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>Change the "Last Updated" date at the top.</li>
            <li>Send an in-app notification to all Learners.</li>
            <li>
              Require a new "Click-Through" agreement for significant changes.
            </li>
          </ul>
        </ContentText>
      </div>

      <Platform />
      <Footer isPlatform />
    </WebLayout>
  );
}
